import { useState } from 'react';

const WORKS_PHOTOS = [
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/28417a2a3e28f1a08e7d2551b2e866cb.jpeg',
    alt: 'Навес с красным поликарбонатом и коваными воротами',
    caption: 'Навес с коваными воротами',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/78603ec7fe11d472a015d61cc1704daa.jpeg',
    alt: 'Кованые распашные ворота с калиткой и забором',
    caption: 'Распашные ворота с кованым забором',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/67c82cf4aa56c2dc68ed0537c0ae750d.jpeg',
    alt: 'Козырёк с кованым орнаментом над дверью',
    caption: 'Козырёк с кованым орнаментом',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/e5d5f6e1140ccb6808d0377e85ebc938.jpeg',
    alt: 'Арочный навес с красным поликарбонатом',
    caption: 'Арочный навес',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/319212bcc422626d0e6733f0deef14ac.jpeg',
    alt: 'Кованые ворота с забором у кирпичного дома',
    caption: 'Ворота с кованым забором',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/5d8deec432fc657d72d157df5507ee4d.jpeg',
    alt: 'Кованый козырёк с двускатной крышей',
    caption: 'Кованый козырёк',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/c990dc13f54f3d235baa02667d00a983.jpeg',
    alt: 'Большой арочный навес для нескольких автомобилей (машин)',
    caption: 'Навес на 3 машины',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/21bb913f27bcf32a9c654938d853e6d2.jpeg',
    alt: 'Козырёк на стойках над входом',
    caption: 'Козырёк над входом',
  },
];

export default function WorksGallery({ productName = 'изделий' }: { productName?: string }) {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const prev = () => setLightbox((p) => (p === null ? null : p === 0 ? WORKS_PHOTOS.length - 1 : p - 1));
  const next = () => setLightbox((p) => (p === null ? null : p === WORKS_PHOTOS.length - 1 ? 0 : p + 1));

  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1200px' }}>
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Наши работы
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Реальные {productName}, изготовленные и смонтированные нашей командой
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {WORKS_PHOTOS.map((photo, idx) => (
            <div
              key={photo.src}
              className="relative overflow-hidden rounded-lg cursor-pointer group"
              style={{ aspectRatio: '4/3' }}
              onClick={() => setLightbox(idx)}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-background-50 text-xs font-medium">{photo.caption}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Social CTA under gallery */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10">
          <a
            href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 hover:scale-[1.03] cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-chat-3-line text-base"></i>
            </span>
            Больше работ в MAX
          </a>
          <a
            href="https://t.me/Gmgmg0202"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap w-full sm:w-auto bg-[#2AABEE] hover:bg-[#1e96d4] text-background-50 font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 hover:scale-[1.03] cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-telegram-line text-base"></i>
            </span>
            Написать в Telegram
          </a>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-sm"
          onClick={() => setLightbox(null)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-4 md:left-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <div className="relative max-w-4xl w-full mx-4 md:mx-16" onClick={(e) => e.stopPropagation()}>
            <img src={WORKS_PHOTOS[lightbox].src} alt={WORKS_PHOTOS[lightbox].alt} className="w-full max-h-[80vh] object-contain rounded-lg" />
            <p className="text-background-50/80 text-sm text-center mt-3">{WORKS_PHOTOS[lightbox].caption}</p>
            <span className="absolute top-3 right-3 text-background-50/60 text-xs">{lightbox + 1} / {WORKS_PHOTOS.length}</span>
          </div>
          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-4 md:right-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      )}
    </section>
  );
}